import { CreditCard, LogOut } from "lucide-react";
import { Button } from "@heroui/button";
import { toast } from "sonner";
import { Link } from "@heroui/link";

import { AuthStore } from "../store/useAuthStore";
import { useLogout } from "../features/Auth/AuthApi";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu.jsx";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "./ui/sidebar.jsx";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

import logoSmall from "/public/logo-small.png";

export function NavUser() {
  const { isMobile } = useSidebar();
  const { userInfo } = AuthStore();

  const { mutateAsync, isSuccess, reset } = useLogout();

  const handleLogout = () => {
    toast.promise(mutateAsync(), {
      loading: "Logging out...",
      success: "Successfully logged out",
      error: "Error logging out",
      position: "top-right",
      duration: 1000,
    });
    if (isSuccess) {
      reset();
    }
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              className="data-[state=open]:bg-gray-200 h-full
              dark:data-[state=open]:bg-gray-700 data-[state=open]:text-gray-800 dark:data-[state=open]:text-gray-200 md:h-8 md:p-0 dark:hover:bg-gray-800  transition-colors duration-200"
              id={"avatarOption"}
              size="lg"
            >
              <Avatar className="h-8 w-8 rounded-lg">
                <AvatarImage
                  alt={"avatar Image"}
                  src={logoSmall}
                  height="32"
                  width="32"
                />
                <AvatarFallback className="rounded-lg">CN</AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">
                  {userInfo.firstname}
                </span>
                <span className="truncate text-xs">{userInfo.email}</span>
              </div>
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg shadow-lg"
            side={isMobile ? "bottom" : "right"}
            sideOffset={4}
          >
            <DropdownMenuLabel className="px-4 font-normal dark:text-gray-200">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm dark:text-gray-200">
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">
                    {userInfo.firstname}
                  </span>
                  <span className="truncate text-xs">{userInfo.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem>
                <Button
                  fullWidth
                  as={Link}
                  className={"text-start flex flex-row justify-start"}
                  href={"/settings"}
                  variant={"light"}
                >
                  <CreditCard size={15} />
                  Settings
                </Button>
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuItem className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors duration-200">
              <DropdownMenuSeparator />
              <Button
                fullWidth
                className={"text-start flex flex-row justify-start"}
                variant={"light"}
                onClick={handleLogout}
              >
                <LogOut size={15} />
                Log Out
              </Button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
